import React from 'react';
import { FadeIn } from './ui';
export const WhoFor = () => {
  return <section className="py-16 px-6" data-id="element-154">
      <div className="max-w-4xl mx-auto" data-id="element-155">
        <div className="grid md:grid-cols-2 gap-12 md:gap-8" data-id="element-156">
          <FadeIn data-id="element-157">
            <div className="bg-surface/50 rounded-2xl p-8 border border-white/5 h-full" data-id="element-158">
              <h3 className="text-2xl mb-8 text-amber font-serif italic" data-id="element-159">
                Who this is for
              </h3>
              <ul className="space-y-6" data-id="element-160">
                {['High-achievers who can\'t stop "winning" tasks in their head at night.', 'Parents who finally get quiet time at 11 PM, only for their brains to start racing.', 'Professionals who wake up at 3 AM and immediately start checking their mental to-do list.', 'Anyone tired of feeling like a "zombie" during the day because of a 90-minute midnight loop.'].map((text, i) => <li key={i} className="flex gap-4 items-start" data-id="element-161">
                    <span className="text-amber/50 mt-1.5 text-sm" data-id="element-162">✦</span>
                    <span className="text-parchment-muted font-light leading-relaxed" data-id="element-163">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-164">
            <div className="p-8 h-full" data-id="element-165">
              <h3 className="text-2xl mb-8 text-parchment-dark font-serif italic" data-id="element-166">
                Who this is not for
              </h3>
              <ul className="space-y-6" data-id="element-167">
                {['Those looking for medical or pharmaceutical prescriptions.', 'People unwilling to spend 5 minutes practicing a new mental habit.', 'People with clinical sleep apnea who require medical machinery.'].map((text, i) => <li key={i} className="flex gap-4 items-start opacity-70" data-id="element-168">
                    <span className="text-parchment-dark mt-1.5 text-sm" data-id="element-169">
                      —
                    </span>
                    <span className="text-parchment-muted font-light leading-relaxed" data-id="element-170">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};